import gql from "graphql-tag";

const statusAffiliates = gql`
  query statusAffiliates {
    searchGeneralTypesBy(type: 26) {
      subtype
      type
      class
      subclass
    }
  }
`;

const getInfoAgencyByID = gql`
  query getInfoAgencyByID($agencyID: Int!) {
    getInfoAgencyByID(agencyID: $agencyID) {
      id
      name
      address
    }
  }
`;

const getAffiliatesByAgencyID = gql`
  query GetAffiliatesByAgencyID(
    $agencyID: Int!
    $nameAffiliate: String
    $offset: Int
    $limit: Int
  ) {
    getAffiliatesByAgencyID(
      agencyID: $agencyID
      nameAffiliate: $nameAffiliate
      offset: $offset
      limit: $limit
    ) {
      count
      rows {
        userID
        isAffiliateDali
        User {
          names
          lastname
          documentNumber
          phone
          email
          picture
        }
        Status {
          subtype
          subclass
        }
        currentVehicleID
        CurrentVehicle {
          id
          vehiclePlate
          categoryVehicleID
        }
        Step {
          id
          name
        }
      }
    }
  }
`;

const getAllCountries = gql`
  query getAllCountries {
    getAllCountries {
      id
      name
      prefixPhone
      urlFlag
      Cities {
        id
        name
      }
    }
  }
`;

const getDataFromPreAffiliate = gql`
  query getDataFromPreAffiliate($affiliateID: String) {
    getDataFromPreAffiliate(affiliateID: $affiliateID) {
      userID
      independentDriverOfMP
      User {
        names
        lastname
        documentNumber
        documentTypeID
        birthdate
        studyLevelID
        bankID
        accountNumber
        documentBackPhoto
        documentFrontPhoto
        passportPhoto
        picture
        hasCovid
        personalRUC
        phone
        email
        nationalityID
        Nationality {
          alpha
          country
          demonym2
        }
      }
      CurrentVehicle {
        categoryVehicleID
        vehiclePlate
      }
      AffiliateDriveInfo {
        driverLicenceNumber
        driverLicenceExpirationDate
        soatPhoto
        driverLicencePhoto
        driverLicenceCategoryID
      }
      paymentDate
      paymentVoucher
      paymentNumberOperation
      viewVideo
      completeTest
      createdAt
    }
  }
`;

const typeVehicleAffiliates = gql`
  query typeVehicleAffiliates {
    searchGeneralTypesBy(type: 13) {
      subtype
      type
      class
      subclass
    }
  }
`;

const documentTypeAffiliates = gql`
  query documentTypeAffiliates {
    searchGeneralTypesBy(type: 23) {
      subtype
      type
      class
      subclass
    }
  }
`;

const categoryLicenceAffiliates = gql`
  query categoryLicenceAffiliates {
    searchGeneralTypesBy(type: 30) {
      subtype
      type
      class
      subclass
    }
  }
`;

export {
  statusAffiliates,
  getInfoAgencyByID,
  getAffiliatesByAgencyID,
  getAllCountries,
  getDataFromPreAffiliate,
  typeVehicleAffiliates,
  documentTypeAffiliates,
  categoryLicenceAffiliates,
};
